import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The npm registry contains packages, many of which are also Node modules, or contain Node modules. Read on to understand how they differ and how they interact.`}</p>
    <h2>{`About packages`}</h2>
    <p>{`A `}<strong parentName="p">{`package`}</strong>{` is a file or directory that is described by a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file. A package must contain a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file in order to be published to the npm registry. For more information on creating a `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` file, see "`}<a parentName="p" {...{
        "href": "creating-a-package-json-file"
      }}>{`Creating a package.json file`}</a>{`".`}</p>
    <p>{`Packages can be unscoped or scoped to a user or organization, and scoped packages can be private or public. For more information, see`}</p>
    <ul>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "about-scopes"
        }}>{`About scopes`}</a>{`"`}</li>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "about-private-packages"
        }}>{`About private packages`}</a>{`"`}</li>
      <li parentName="ul">{`"`}<a parentName="li" {...{
          "href": "package-scope-access-level-and-visibility"
        }}>{`Package scope, access level, and visibility`}</a>{`"`}</li>
    </ul>
    <h3>{`About package formats`}</h3>
    <p>{`A package is any of the following:`}</p>
    <ul>
      <li parentName="ul">{`a) A folder containing a program described by a `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file.`}</li>
      <li parentName="ul">{`b) A gzipped tarball containing (a).`}</li>
      <li parentName="ul">{`c) A URL that resolves to (b).`}</li>
      <li parentName="ul">{`d) A `}<inlineCode parentName="li">{`<name>@<version>`}</inlineCode>{` that is published on the registry with (c).`}</li>
      <li parentName="ul">{`e) A `}<inlineCode parentName="li">{`<name>@<tag>`}</inlineCode>{` that points to (d).`}</li>
      <li parentName="ul">{`f) A `}<inlineCode parentName="li">{`<name>`}</inlineCode>{` that has a `}<inlineCode parentName="li">{`latest`}</inlineCode>{` tag satisfying (e).`}</li>
      <li parentName="ul">{`g) A `}<inlineCode parentName="li">{`git`}</inlineCode>{` url that, when cloned, results in (a).`}</li>
    </ul>
    <h3>{`npm package git URL formats`}</h3>
    <p>{`Git URLs used for npm packages can be formatted in the following ways:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`git://github.com/user/project.git#commit-ish`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`git+ssh://user@hostname:project.git#commit-ish`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`git+http://user@hostname/project/blah.git#commit-ish`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`git+https://user@hostname/project/blah.git#commit-ish`}</inlineCode></li>
    </ul>
    <p>{`The `}<inlineCode parentName="p">{`commit-ish`}</inlineCode>{` can be any tag, sha, or branch that can be supplied as
an argument to `}<inlineCode parentName="p">{`git checkout`}</inlineCode>{`. The default `}<inlineCode parentName="p">{`commit-ish`}</inlineCode>{` is `}<inlineCode parentName="p">{`master`}</inlineCode>{`.`}</p>
    <h2>{`About modules`}</h2>
    <p>{`A `}<strong parentName="p">{`module`}</strong>{` is any file or directory in the `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` directory that can be loaded by the Node.js `}<inlineCode parentName="p">{`require()`}</inlineCode>{` function.`}</p>
    <p>{`To be loaded by the Node.js `}<inlineCode parentName="p">{`require()`}</inlineCode>{` function, a module must be one of the following:`}</p>
    <ul>
      <li parentName="ul">{`A folder with a `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file containing a `}<inlineCode parentName="li">{`"main"`}</inlineCode>{` field.`}</li>
      <li parentName="ul">{`A JavaScript file.`}</li>
    </ul>
    <div className="note">
      <span className="bold">**Note:** </span>
Since modules are not required to have a `package.json` file, not all modules are packages. Only modules that have a `package.json` file are also packages.
    </div>
    <p>{`In the context of a Node program, the `}<inlineCode parentName="p">{`module`}</inlineCode>{` is also the thing that
was loaded `}<em parentName="p">{`from`}</em>{` a file. For example, in the following program:`}</p>
    <pre><code parentName="pre" {...{}}>{`var req = require('request')
`}</code></pre>
    <p>{`we might say that "The variable `}<inlineCode parentName="p">{`req`}</inlineCode>{` refers to the `}<inlineCode parentName="p">{`request`}</inlineCode>{` module".`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      